import React from "react";
import PropTypes from "prop-types";

const ImageViewer = ({ images }) => {
  if (!Array.isArray(images) || images.length === 0) return null;

  const safeImages = images.filter((img) => img && typeof img.url === "string");
  if (safeImages.length === 0) return null;

  const count = safeImages.length;
  const layoutCount = count > 3 ? 3 : count;
  const containerClass = `markdown-image-viewer images-${layoutCount}`;

  return (
    <div className={containerClass}>
      {safeImages.map((img, index) => (
        <div key={index} className="markdown-image-wrapper">
          <img
            src={img?.url}
            alt={img?.alt || img?.caption || `Image ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
          {img?.caption && (
            <div className="markdown-image-caption">{img?.caption}</div>
          )}
        </div>
      ))}
    </div>
  );
};

ImageViewer.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string.isRequired,
      alt: PropTypes.string,
      caption: PropTypes.string,
    })
  ),
};

ImageViewer.defaultProps = {
  images: [],
};

export default ImageViewer;
